<!-- un enfant du chronocode en mode création -->
<wiz-vgroup #mainGP width="100%" padding="10px">
  <wiz-button #btShowHide class="listButton" [wizIcon]="'reduce'"></wiz-button>

  <wiz-hgroup [visible]="contentVisible" horizontalAlign="space-between">
    <!--  zone de saisie -->
    <wiz-vgroup width="100%" #hgPeriodDefinition wizValidationContainer>
      <!-- zone timeGap et titre du level -->
      <wiz-hgroup wizValidationContainer gap="10">
        <wiz-dropdown
          #ddlTimeGap
          wizValidator
          [wizLabel]="'$.chronocode.create.level.timegap.$'"
          width="200px"
          [wizLabelField]="'trsLabel'"
          [wizPlaceholder]="'$.chronocode.timegap.none.$'"
          [wizDisabled]="chroTemplate.hasChild"
        >
        </wiz-dropdown>
        <wiz-translation
          #tiLabel
          width="200px"
          wizValidator
          [wizLabel]="'$.chronocode.level.label.$'"
          [wizShowErrors]="true"
          [wizMandatory]="true"
        ></wiz-translation>
      </wiz-hgroup>

      <!-- Jour de debut pour les découpage en semaine -->
      <wiz-vgroup [visible]="isTimeGapWeek" wizValidationContainer>
        <wiz-dropdown
          #ddlWeekStart
          [wizLabel]="'$.chronocode.create.level.weekstart.$'"
          [wizMandatory]="true"
          width="200px"
          [wizDataProvider]="weekStartDS"
          [wizFakeLabel]="'default'"
          [wizDisabled]="chroTemplate.hasChild"
          [wizLabelField]="'trsLabel'"
        >
        </wiz-dropdown>
        <wiz-radio-group [wizValue]="'01'" #rgWeekName>
          <wiz-radio-button [wizLabel]="'$.chronocode.weekstart.default.day.$'" [wizValue]="'01'"></wiz-radio-button>
          <wiz-radio-button [wizLabel]="'$.chronocode.weekstart.choosen.day.$'" [wizValue]="'02'"></wiz-radio-button>
        </wiz-radio-group>
      </wiz-vgroup>

      <!-- regexp de nommage -->
      <wiz-hgroup
        #vgDetail
        [visible]="detailVisible"
        verticalAlign="center"
        wizValidationContainer
        horizontalAlign="space-between"
        wizValidationContainer
      >
        <wiz-hgroup [visible]="regexpVisible()" wizValidationContainer>
          <wiz-text-input
            #tiRegex
            [wizLabel]="'$.chronocode.create.level.regex.$'"
            [wizMandatory]="true"
          ></wiz-text-input>
          <wiz-dropdown
            #ddlRegexIndexFormat
            [wizLabel]="'$.chronocode.index.format.$'"
            width="200px"
            [wizDataProvider]="indexFormatDS"
            [wizLabelField]="'label'"
            [wizMandatory]="true"
          ></wiz-dropdown>
        </wiz-hgroup>
      </wiz-hgroup>

      <!-- découpage manuel sur undefined -->
      <wiz-vgroup
        [visible]="isLevelUndefined"
        verticalAlign="center"
        horizontalAlign="space-between"
        gap="10"
        wizValidationContainer
      >
        <wiz-hgroup wizValidationContainer>
          <wiz-label [wizLabel]="'$.chronocode.create.level.childnum.$'"></wiz-label>
          <wiz-numeric-input
            #niChildNumber
            width="40px"
            [wizDisabled]="chroTemplate.hasChild"
            [wizMinNumber]="1"
            [allowNegative]="false"
            [nbDecimal]="0"
            [wizMaxChars]="2"
            [wizMaxNumber]="50"
          ></wiz-numeric-input>
        </wiz-hgroup>

        <wiz-hgroup verticalAlign="center" (click)="toggleShowEditDetail()" [visible]="canAddSubLevel">
          <wiz-button #btShowHidePeriods [wizIcon]="'add'" width="20px" height="20px"></wiz-button>
          <wiz-label [wizLabel]="'$.chronocode.create.level.editdetail.$'"></wiz-label>
        </wiz-hgroup>

        <wiz-vgroup [visible]="showUndefinedDetail" maxHeight="400px" style="overflow: auto">
          <wiz-hgroup wizValidationContainer #hgMain verticalAlign="center" gap="5">
            <wiz-spacer width="16px"></wiz-spacer>
            <wiz-label width="120px" [wizLabel]="'$.chronocode.level.name.label.$'"></wiz-label>
            <wiz-label width="100px" [wizLabel]="'$.chronocode.level.start.date.$'"></wiz-label>
            <wiz-label width="100px" [wizLabel]="'$.chronocode.level.end.date.$'"></wiz-label>
          </wiz-hgroup>
          <ng-container *ngFor="let chronocode of undefinedPeriods; let idx = index;">
            <chrono-detail-edit-renderer
              [chronocode]="chronocode"
              [parentGroup]="this"
              width="100%"
            ></chrono-detail-edit-renderer>
          </ng-container>
        </wiz-vgroup>
      </wiz-vgroup>
    </wiz-vgroup>

    <!-- bouton générer et add sub -->
    <wiz-vgroup width="200px">
      <wiz-button
        #btnCancel
        class="cancel-button"
        [wizIcon]="'arrow-left'"
        width="100%"
        [wizLabel]="'$.chronocode.delete.sub.level.$'"
        (wizClick)="deleteLevel()"
        height="30px"
      ></wiz-button>
      <wiz-spacer height="100%"></wiz-spacer>
      <wiz-button
        #btnSubLevel
        [wizIcon]="'add'"
        [visible]="canAddSubLevel"
        [wizLabel]="'$.chronocode.add.sub.level.$'"
        width="100%"
        height="40px"
      ></wiz-button>
    </wiz-vgroup>
  </wiz-hgroup>
</wiz-vgroup>
